import {
    faCheck,
    faExclamationTriangle,
    faSpinner,
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";

import loading from "@/services/loading";
import {ELoadingStatus} from "@/services/models";

import Toast from "@toolbox/modals/Toast";
import T from "@translate/T";
import {boundMethod} from "autobind-decorator";

interface ILoadingIndicatorState {
    status: ELoadingStatus;
    count: number;
}

class LoadingIndicator extends React.PureComponent<{}, ILoadingIndicatorState> {
    public readonly state: ILoadingIndicatorState = {
        status: loading.status,
        count: 0,
    };

    private unsubscribe?: () => void;

    public componentDidMount() {
        this.unsubscribe = loading.subscribe({
            loadingChanged: (status, count) => this.setState({status, count}),
        });
    }

    public componentWillUnmount() {
        this.unsubscribe?.();
    }

    @boundMethod
    public onClick(e: React.SyntheticEvent) {
        e.preventDefault();

        this.setState({status: ELoadingStatus.Nothing});
    }

    public render() {
        const {status, count} = this.state;

        if (status === ELoadingStatus.Nothing && count <= 0) {
            return null;
        }

        return <Toast>{this.renderMsg()}</Toast>;
    }

    private renderMsg() {
        const {status, count} = this.state;

        if (status === ELoadingStatus.Failed && count <= 0) {
            return (
                <div className="alert alert-danger mb-0">
                    <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        fixedWidth={true}
                        className="mr-1"
                    />
                    <T>Something went wrong, please try again.</T>

                    <button
                        type="button"
                        className="close"
                        aria-label="close"
                        onClick={this.onClick}
                    >
                        <FontAwesomeIcon
                            icon={faTimes}
                            fixedWidth={true}
                            size="sm"
                        />
                    </button>
                </div>
            );
        }

        if (status === ELoadingStatus.Success && count <= 0) {
            return (
                <div className="alert alert-success mb-0">
                    <FontAwesomeIcon
                        icon={faCheck}
                        fixedWidth={true}
                        className="mr-1"
                    />
                    <T>Successfully done.</T>
                </div>
            );
        }

        return (
            <div className="alert alert-info mb-0">
                <FontAwesomeIcon
                    icon={faSpinner}
                    fixedWidth={true}
                    className="mr-1"
                    spin={true}
                />
                <T>Request in progress, please wait...</T>
            </div>
        );
    }
}

export default LoadingIndicator;
